export default __webpack_public_path__ + "static/media/HydraulicSystemsImg.1270de73.jpg";